import { Component, OnInit, EventEmitter } from '@angular/core';
import { ConfirmService } from './confirm.service';

@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.css']
})
export class ConfirmComponent implements OnInit {
  showConfirm = false;
  eventEmitter: any; // actually of type EventEmitter
  confirmClass = 'confirm-primary';
  message = 'some message';
  constructor(private confirmservice: ConfirmService) { }

  ngOnInit(): void {
    this.eventEmitter = this.confirmservice.getEventEmitter();
    this.eventEmitter.subscribe(
      (result: any) => {
        this.confirmClass = result.confirmClass;
        this.message = result.message;
        this.showConfirm = true;
      });
  }
  yes(){
    this.confirmservice.yes()
    this.showConfirm = false;
  }
  no(){
    this.confirmservice.no()
    this.showConfirm = false;
  }

}
